import React from "react";
import PropTypes from "prop-types";

const TrafficConeIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#traffic-cone-icon-clip)">
        <path
          d="M14.4876 12.0005L9.15426 2.66714C8.91751 2.24939 8.47443 1.99121 7.99426 1.99121C7.51409 1.99121 7.07101 2.24939 6.83426 2.66714L1.50093 12.0005C1.26166 12.4149 1.26279 12.9257 1.50389 13.339C1.745 13.7524 2.18911 14.0048 2.6676 14.0005H13.3343C13.8104 14 14.2501 13.7457 14.4879 13.3332C14.7258 12.9208 14.7257 12.4128 14.4876 12.0005"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 6V8.66667"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11.333H8.00667"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="traffic-cone-icon-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TrafficConeIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TrafficConeIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default TrafficConeIcon;
